import Column from '@components/Column';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

import styles from './styles.module.scss';

interface Props {
    header?: ReactNode;
    children?: ReactNode;
    footer?: ReactNode;
    noFooterBorder?: boolean;
    footerPosition?: 'FIXED' | 'RELATIVE';
 }

function CtaLayout({
  children, header, footer, noFooterBorder, footerPosition,
}:Props) {
  const isRelative = footerPosition === 'RELATIVE';
  return (
        <Column fullWidth fullHeight aria-label='cta'>
            {header}
            <Column fullWidth className={styles.contents}
                    id='cta-contents'
                    data-scroll-restoration={true} >
                {children}
                {(isRelative && footer) && (
                    <Footer noBorder={noFooterBorder}>
                        {footer}
                    </Footer>
                )}
            </Column>
            {(!isRelative && footer) && (
                <Footer noBorder={noFooterBorder}>
                    {footer}
                </Footer>
            )}
        </Column>
  );
}

const Footer = styled.div<{
    noBorder?: boolean;
}>`
    &:has(*) {
        background-color: ${colors.white};
        border-top: ${(props) => (props.noBorder ? 'none' : '1px solid var(--color-gray2)')};
        padding: 20px 18px calc(12px + var(--safe-area-bottom));
        width: 100%;
        z-index: 2;
    }`;

export default CtaLayout;
